<template>
  <svg fill="currentColor"
       xmlns="http://www.w3.org/2000/svg"
       width="9.248"
       height="9.249"
       viewBox="0 0 9.248 9.249"
  >
    <path id="Union_1"
          data-name="Union 1"
          d="M-1121.992,3117.414v-3.925h-3.924v-1.4h3.924v-3.925h1.4v3.925h3.924v1.4h-3.924v3.925Z"
          transform="translate(1125.916 -3108.165)"
    />
  </svg>
</template>
<script>
export default {
  name: "IconCloseFat"
}
</script>
